import React from "react"
import { graphql } from "gatsby"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import ContentContainer from "../components/contentContainer"
import FluidContainer from "../components/fluidContainer"
import Banner from "../components/banner"
import { Header1 } from "../components/headings"
import ReactMarkdown from "react-markdown"
import SEO from "../components/seo"

const InfoContainer = styled.div`
  background-color: #eaecec;
  padding: 2rem;
  font-family: roboto;
  font-size: 16px;
  font-weight: 300;
  color: black;
`
const Safety = ({ data }) => (
  <Layout>
    <SEO title="Safety" keywords={[`eating`, `contests`, `official`]} />
    <FluidContainer>
      <ContentContainer>
        <InfoContainer>
          <Header1>{data.strapiPages.title}</Header1>
          <ReactMarkdown
            escapeHtml={false}
            source={data.strapiPages.mainCopy}
          />
        </InfoContainer>
      </ContentContainer>
    </FluidContainer>
  </Layout>
)

export default Safety

export const pageQuery = graphql`
  query SafetyQuery {
    strapiPages(selector: { eq: "safety" }) {
      mainCopy
      title
    }
  }
`
